export interface FiscalRegimeModel {
  exchangeInformation: number;
  id: string;
  name: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class FiscalRegime implements FiscalRegimeModel {
  exchangeInformation = 0;
  id = "";
  name = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: FiscalRegimeModel) {
    if (!dto) {
      return;
    }
    this.exchangeInformation = dto.exchangeInformation;
    this.id = dto.id;
    this.name = dto.name;
    this.utcInsertDate = dto.utcInsertDate;
    this.utcUpdateDate = dto.utcUpdateDate;
    this.version = dto.version;
  }
}
